// Reading a delete's outcome, kept free of Angular so it can be unit tested.
//
// A delete that changed nothing used to answer HTTP 200 and reach the caller as
// `true`, so a refused delete was indistinguishable from a completed one and the
// UI reported it as success. The server now separates the cases; these are the
// client's side of that.

//   'not-allowed' — the server refused it; only the owner may delete.
//   'not-found'   — no such plan or template to delete.
//   'failed'      — the request itself did not complete.
export type ProjectDeleteFailureReason = 'not-allowed' | 'not-found' | 'failed';

export interface IProjectDeleteResult {
    succeeded: boolean;
    reason: ProjectDeleteFailureReason | null;
}

// The authorised-http wrapper rejects with the $http response for a server
// answer and with something else entirely when the auth check itself fails, so
// a missing numeric status means "the request never got an answer".
export function deleteFailureReasonFromRejection(rejection: any): ProjectDeleteFailureReason {
    const status = rejection && typeof rejection.status === 'number' ? rejection.status : 0;

    if (status === 403) {
        return 'not-allowed';
    }

    if (status === 404) {
        return 'not-found';
    }

    return 'failed';
}

export function templateDeleteFailureMessage(templateName: string, reason: ProjectDeleteFailureReason | null): string {
    const named = "“" + templateName + "”";

    switch (reason) {
        case 'not-allowed':
            return named + " was not deleted. Only the owner of a template can delete it.";

        case 'not-found':
            return named + " was not found, so it may already have been deleted. The list has been refreshed.";

        default:
            return named + " was not deleted because the request did not reach the server. Check your connection and try again.";
    }
}
